import ApiService from "../../ApiService";

const BookCommentService = {
    loadScreenView: (searchVo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/bookcomment/loadcommentlist", { searchVo }, successCallback, failureCallback);
    },

    searchComments: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/bookcomment/searchcomments", vo, successCallback, failureCallback);
    },

    saveComment: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/bookcomment/savecomment", vo, successCallback, failureCallback);
    },

    deleteComment: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/bookcomment/deletecomment", vo, successCallback, failureCallback);
    },

    saveCommentLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/bookcomment/savecommentlike", vo, successCallback, failureCallback);
    },

    deleteCommentLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/learn/bookcomment/deletecommentlike", vo, successCallback, failureCallback);
    },

};

export default BookCommentService;